import React, { useEffect, useRef } from 'react'
import { MapStore } from 'store/map'
import { DefaultMapView } from 'ui/common/default-map-view'
import { TopNavigationBar } from 'ui/common/top-navigation-bar'
import { useSafeAreaInsets } from 'infra/util'
import { CategoryChip } from 'ui/discovery/category-chip'
import { observer } from 'mobx-react'
import { categorySelectStore } from 'store/category-select'
import { RowLayout } from 'ui/common/layout'
import { HOME_ICON } from 'image/icon'
import { Image, TouchableOpacity } from 'react-native'
import { navigation } from 'navigation/global'
import { PlaceMarker } from 'ui/common/place-marker'
import { useCategoryPlaceList } from 'api/hooks'
import { SelectedPlacePopover } from 'ui/common/place-popover'
import { locationStore } from 'store/location'
import { AREA_ZOOM } from 'infra/constant'
import { isValidPlace } from 'store/places'

export const CategoryDiscoveryScreen = observer(() => {
  const mapStore = useRef(new MapStore()).current
  const { top } = useSafeAreaInsets()
  useEffect(() => {
    if (mapStore.isReady) {
      locationStore
        .getLocation(false)
        .then((x) => mapStore.focusLocation(x, AREA_ZOOM))
        .catch((error) => console.warn('[CategoryDiscoveryLocation]', error))
    }
  }, [mapStore, mapStore.isReady])
  return (
    <DefaultMapView
      mapStore={mapStore}
      MapViewChildren={() => {
        const leafCategory = categorySelectStore.leaf
        const { data } = useCategoryPlaceList(
          leafCategory ? [leafCategory] : null,
        )
        if (!Array.isArray(data?.places)) return null
        return (
          <>
            {data.places.filter(isValidPlace).map((v) => (
              <PlaceMarker key={v.id} place={v} mapStore={mapStore} />
            ))}
          </>
        )
      }}
      MapOverlayChildren={() => {
        return (
          <>
            <TopNavigationBar
              title=''
              containerStyle={{
                backgroundColor: 'transparent',
                marginTop: top + 8,
                alignItems: 'center',
              }}
            >
              <RowLayout
                style={{
                  flex: 1,
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <RowLayout style={{ alignItems: 'center' }}>
                  {categorySelectStore.selectedData.map((x) => (
                    <CategoryChip
                      key={x.id}
                      data={x}
                      isActive={true}
                      isSelected={false}
                      touchDisabled={true}
                      containerStyle={{ marginBottom: 0, marginRight: 8 }}
                    />
                  ))}
                </RowLayout>
                <TouchableOpacity
                  style={{ marginRight: 12 }}
                  onPress={() => {
                    navigation.setRoot('BottomTabs')
                  }}
                >
                  <Image
                    source={HOME_ICON}
                    style={{
                      width: 48,
                      height: 48,
                    }}
                  />
                </TouchableOpacity>
              </RowLayout>
            </TopNavigationBar>
            <SelectedPlacePopover store={mapStore} />
          </>
        )
      }}
    />
  )
})
